import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';

import usePublicApi from 'public-api';
import appRoutes from 'routes/codegen/appRoutes';
import authRoutes from 'routes/codegen/authRoutes';
import { useAsyncFunction, useHistory } from 'stores/hooks';

import ErrorStep from './components/ErrorStep';
import withErrorBoundary from './components/withErrorBoundary';
import DetailsStep from './signup/DetailsStep';
import EmailStep from './signup/EmailStep';
import ProductsStep from './signup/ProductsStep';
import RegistrationStore from './stores/RegistrationStore';

type Props = {
  hasError: boolean;
};

function OnboardingRegister({ hasError }: Props) {
  const history = useHistory();
  const api = usePublicApi();
  const [store] = useState(() => new RegistrationStore(api));

  useEffect(() => {
    store.loadFromSearch(history.location.search);
  }, [store, history.location.search]);

  const next = new URLSearchParams(history.location.search).get('next');
  const loginUrl = authRoutes.authLogin({ lang: window.appState.lang }) + (next ? `?next=${next}` : '');

  const register = async () => {
    if (await store.register()) {
      window.location.href = next || appRoutes.index();
    }
  };
  const [handleRegister, isRegistering] = useAsyncFunction(register);

  if (hasError) return <ErrorStep />;
  if (store.step === 'EMAIL') return <EmailStep store={store} loginUrl={loginUrl} />;
  if (store.step === 'DETAILS') return <DetailsStep store={store} />;
  return <ProductsStep store={store} onSubmit={handleRegister} isSubmitting={isRegistering} />;
}

export default withErrorBoundary(observer(OnboardingRegister));
